import React from 'react';
import { motion } from 'framer-motion';
const testimonials = [{
  quote: 'Después de meses de confusión, apliqué el script del Capítulo 4 y por primera vez vi su verdadera intención. Hoy estamos comprometidos, con fecha y plan claro.',
  author: 'Alejandra R.',
  location: 'Bogotá, Colombia',
  initials: 'AR'
}, {
  quote: 'Este libro fue mi guía para dejar una relación que no avanzaba. La retirada estratégica me dio el poder que había perdido. Ahora estoy en paz y con otra mentalidad.',
  author: 'Mónica G.',
  location: 'Ciudad de México',
  initials: 'MG'
}, {
  quote: 'Los scripts son oro puro. Nunca supe cómo hablar de esto sin que pareciera un ultimátum. Este método me enseñó a hablar desde mi valor, no desde el miedo.',
  author: 'Valentina L.',
  location: 'Miami, Florida',
  initials: 'VL'
}];
export function TestimonialsSection() {
  return <section className="py-10 md:py-14 px-6 bg-cream relative" data-id="element-240">
      <div className="max-w-6xl mx-auto" data-id="element-241">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10" data-id="element-242">
          <p className="text-gold font-bold uppercase tracking-widest text-sm mb-3" data-id="element-243">
            Resultados reales
          </p>
          <h2 className="text-2xl md:text-4xl font-bold mb-4 text-burgundy" data-id="element-244">
            Mujeres que tomaron el control
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-245">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="bg-white p-6 shadow-lg border-t-4 border-gold flex flex-col h-full" data-id="element-246">
              <div className="text-gold text-lg mb-4 tracking-widest" data-id="element-247">
                ★★★★★
              </div>
              <p className="text-gray-800 italic mb-6 flex-grow text-sm md:text-base leading-relaxed" data-id="element-248">
                "{testimonial.quote}"
              </p>
              <div className="flex items-center mt-auto pt-4 border-t border-gray-100" data-id="element-249">
                <div className="w-10 h-10 bg-blush rounded-full flex items-center justify-center text-burgundy font-bold text-sm mr-3 flex-shrink-0" data-id="element-250">
                  {testimonial.initials}
                </div>
                <div data-id="element-251">
                  <p className="font-bold text-burgundy text-sm md:text-base" data-id="element-252">
                    {testimonial.author}
                  </p>
                  <p className="text-gray-500 text-xs" data-id="element-253">
                    {testimonial.location}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}